<!--
 * @Description:
 * @Author: yangguang
 * @Date: 2022-03-05 15:10:27
 * @LastEditors: yangguang
 * @LastEditTime: 2022-03-07 23:53:46
-->
<template>
  <div id="app">
    <!-- <headers  v-if="$route.name!=='login'&&$route.name!=='wxLogin'&&$route.name!=='binding'" /> -->
    <router-view />
    <!-- <footers  v-show="$route.name!=='login'&&$route.name!=='wxLogin'&&$route.name!=='binding'&&$route.name!=='share'" /> -->
  </div>
</template>

<script>
// import Header from './components/Header'
// import Footer from './components/Footer'
export default {
  name: 'App',
  // components: {
  //   headers: Header,
  //   footers: Footer
  // },
  // watch: {
  //     $route() {
  //       if (window._czc) {
  //         let location = window.location;
  //         let contentUrl = location.pathname + location.hash;
  //         let refererUrl = "/";
  //         window._czc.push(["_trackPageview", contentUrl, refererUrl]);
  //       }
  //     }
  // },
  // mounted () {
  //   // 友盟统计添加
  //   const script = document.createElement("script");
  //   script.src = "https://v1.cnzz.com/z_stat.php?id=1280776416&web_id=1280776416";
  //   script.language = "JavaScript";
  //   document.body.appendChild(script);
  // },
}
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  /* background: #F5F5F5; */
}
html {
  width: 100%;
  height: 100%;
  //min-width: 1400px;
}

body {
  position: relative;
  margin: 0;
  padding: 0;
  overflow: auto;
}
.el-carousel__indicators--horizontal {
  bottom: 80px !important;
  left: 50%;
  transform: translateX(-50%);
}
.el-carousel__button {
  width: 60px !important;
  height: 3px !important;
}
.el-popup-parent--hidden {
  padding: 0 !important;
}
.v-modal {
  z-index: 997 !important;
}
/* .el-tabs__nav {
  position: relative;
  background: #fff;
  margin: 0 50%;
  left: -270px;
} */

.el-carousel__item {
  background-color: #f5f5f5 !important;
}
/* .registerTab .el-tabs__nav-scroll {
  text-align: center !important;
}
.registerTab .el-tabs__nav {
  float: none !important;
}
.registerTab .el-tabs__active-bar {
  display: none !important;
} */

.el-dialog{
  margin-top: 20px !important
}
.testRequirement{
  .el-form-item__content{
    width: 100%;
  }
}
.order-list{
  .el-card__header{
    display: flex;
  }
}
.paymentmMethod {
  .el-dialog {
    margin-top: 250px !important;
    width: 400px !important;
    height: 300px !important;
    .el-dialog__body{
      margin-top: 30px;
      margin-bottom: 10px;
    }
    .el-dialog__footer{
      text-align: center;
    }
  }
}
.address{
  .el-dialog {
    margin-top: 200px !important;
    width: 500px !important;
    height: 200px !important;
    .el-dialog__footer{
      text-align: center;
    }
  }
}
.discount{
  .dialogRule{
    .el-dialog {
      margin-top: 300px !important;
      border-radius: 15px !important;
      .el-dialog__header{
        border-radius: 20px 20px 0px 0px!important;
      }
      .el-dialog__title{
        color: #ee8d26e0;
        font-size: 23px;
      }
    }
  }
  .dialogCoupon{
    .el-dialog {
      margin-top: 300px !important;
      border-radius: 15px !important;
      background-color: rgba(232, 232, 232, 0.98);
      .el-dialog__header{
        border-radius: 20px 20px 0px 0px!important;
        height: 0;
      }
      .el-dialog__title{
        font-size: 18px;
      }
    }
  }

}
.consulting{
  .el-dialog {
    .el-dialog__body{
      text-align: center;
    }
  }
}
.informationPopup{
  .el-dialog {
    .el-dialog__body{
      height: 500px;
      overflow: auto;
    }
  }
}
.item .el-form-item__label{
  color: #388ce1;
}
.el-step__title.is-finish{
  font-size: 14px;
}

.zdylm{
  padding-left: 3rem;
  min-width:40rem!important;
  min-height: 10rem!important;
  font-size: 6rem !important;
  margin-top: 12rem;
  border-radius: 2rem !important;
  .el-message__content{
    font-size: 4rem;
    padding-left: 4rem;
  }
}
.appLoadingClass{
  font-size: 6rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue